import { Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail, Instagram } from "lucide-react";
import { DarkModeToggle } from "@/components/pro/DarkModeToggle";
import { COMPANY } from "@/data/services";

export default function ProHeader() {
  return (
    <header
      data-testid="pro-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 dark-bg-header border-b border-slate-200 dark-border"
    >
      {/* Barra superior con contactos */}
      <div className="bg-slate-900 dark-bg-card-strong text-white text-[11px]">
        <div className="container mx-auto px-4 md:px-8 h-8 flex items-center justify-between gap-4">
          <div className="hidden md:flex items-center gap-5">
            <a href={`tel:+34${COMPANY.whatsapp}`} className="flex items-center gap-1.5 hover:text-emerald-300 transition-colors">
              <Phone className="w-3 h-3" /> {COMPANY.whatsappFormatted}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-1.5 hover:text-emerald-300 transition-colors">
              <Mail className="w-3 h-3" /> {COMPANY.email}
            </a>
            <a href={`https://instagram.com/${COMPANY.instagram}`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 hover:text-emerald-300 transition-colors">
              <Instagram className="w-3 h-3" /> @{COMPANY.instagram}
            </a>
          </div>
          <div className="text-slate-300 uppercase tracking-wider font-semibold">
            Modo profesional · Generador de presupuestos
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/pro" className="flex items-center gap-3 shrink-0" data-testid="pro-logo-link">
          <img
            src={COMPANY.logo}
            alt={COMPANY.name}
            className="w-11 h-11 rounded-lg object-contain bg-white border border-slate-200 dark-border shadow-sm p-0.5"
            data-testid="pro-header-logo"
          />
          <div className="leading-tight">
            <div className="font-display font-semibold text-[15px] text-slate-900 dark-text-strong">{COMPANY.shortName}</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-emerald-700 dark-text-accent font-semibold">S.L.U. · {COMPANY.area}</div>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          <Link
            to="/"
            data-testid="pro-back-public"
            className="hidden sm:inline-flex items-center gap-2 h-9 px-3 rounded-lg border border-slate-200 dark-border text-slate-700 dark-text-mid text-sm font-medium hover:border-emerald-500 hover:text-emerald-600 transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Web pública
          </Link>
          <DarkModeToggle />
        </div>
      </div>
    </header>
  );
}
